import intl from 'react-intl-universal';
import { useEffect, useState } from 'react';
import { Input, Spin, Image, message, Empty, Checkbox } from 'antd';
import { CheckSquareFilled } from '@ant-design/icons';
// import { getUserSessionInfo } from '@/api/common';
import { getSessionImgs } from '@/api/common';

const { Search } = Input;

import style from '../index.less';

interface Props {
    sessionId?: string;
    value?: string[];
    onChange?: (values: string[]) => void;
}

const ZcUpload = (props: Props) => {
    const { sessionId } = props;
    const [images, setImages] = useState<string[]>([]);
    const [videos, setVideos] = useState<string[]>([]);
    const [selectFiles, setSelectFiles] = useState<string[]>(props.value || []);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);

    const [allCheck, setAllCheck] = useState(false);

    console.log('-=-=', selectFiles);
    const indeterminate =
        selectFiles.length > 0 &&
        selectFiles.length < images.length + videos.length;

    useEffect(() => {
        if (sessionId) {
            onSearch(sessionId);
        }
    }, [sessionId]);

    const onSearch = async (value: string) => {
        if (!value) return;

        setSearchLoading(true);
        props.onChange?.([]);

        try {
            const { data } = await getSessionImgs({
                sessionId: value,
            });
            // const videosResult = await getUserSessionInfo({
            //     cid: value,
            //     type: 2,
            // });
            setImages(
                data?.records
                    ?.filter((item) => item.fileUrl && item.messageType === 2)
                    ?.map((item) => {
                        // 给图片加随机串标识唯一，以防出现同时两张 url 一样的图片，删除不好处理
                        if (item.fileUrl.includes('?')) {
                            return item.fileUrl + '&v=' + new Date().getTime();
                        } else {
                            return item.fileUrl + '?v=' + new Date().getTime();
                        }
                    }) || [],
            );
            setVideos(
                data?.records
                    ?.filter(
                        (item) =>
                            item.fileUrl && [3, 4].includes(item.messageType),
                    )
                    ?.map((item) => {
                        // 给图片加随机串标识唯一，以防出现同时两张 url 一样的图片，删除不好处理
                        if (item.fileUrl.includes('?')) {
                            return item.fileUrl + '&v=' + new Date().getTime();
                        } else {
                            return item.fileUrl + '?v=' + new Date().getTime();
                        }
                    }) || [],
            );
            setSearchLoading(false);
        } catch (e) {
            setImages([]);
            setVideos([]);
            setSearchLoading(false);
            message.error(intl.get('未知错误，请重试'));
        }
    };

    const selectFilesChange = (url: string) => {
        const index = selectFiles.indexOf(url);
        if (index > -1) {
            selectFiles.splice(index, 1);
        } else {
            selectFiles.push(url);
        }

        props.onChange?.(selectFiles);
        setSelectFiles([...selectFiles]);
        console.log('---3333', selectFiles);
        if (!selectFiles.length) {
            setAllCheck(false);
        } else {
            setAllCheck(true);
        }
    };

    const onAllCheckChange = (e) => {
        const value = e.target.checked;
        setAllCheck(value);
        if (value) {
            props.onChange?.([...images, ...videos]);
            setSelectFiles([...images, ...videos]);
        } else {
            props.onChange?.([]);
            setSelectFiles([]);
        }
    };

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Search
                    placeholder={intl.get('请输入会话ID')}
                    allowClear
                    enterButton={intl.get('搜索')}
                    style={{ width: 450 }}
                    defaultValue={sessionId}
                    onSearch={onSearch}
                    loading={searchLoading}
                    size="middle"
                />

                {images.length || videos.length ? (
                    <>
                        <Checkbox
                            checked={allCheck}
                            indeterminate={indeterminate}
                            onChange={onAllCheckChange}
                        >
                            {intl.get('全选')}
                        </Checkbox>
                    </>
                ) : (
                    ''
                )}
            </div>

            <Spin
                tip="Loading..."
                spinning={searchLoading}
            >
                <div className={style.mediaContainer}>
                    {images?.map((image) => (
                        <li key={image}>
                            <Image
                                width={200}
                                // preview={false}
                                src={image}
                            ></Image>
                            <div
                                className={style.checkBox}
                                onClick={() => selectFilesChange(image)}
                            >
                                {selectFiles.includes(image) && (
                                    <CheckSquareFilled
                                        style={{
                                            fontSize: 20,
                                            color: '#09f',
                                        }}
                                    />
                                )}
                            </div>
                        </li>
                    ))}
                </div>
                <div className={style.mediaContainer}>
                    {videos?.map((image) => (
                        <li key={image}>
                            <video
                                width={200}
                                src={image}
                            ></video>
                            <div
                                className={style.checkBox}
                                onClick={() => selectFilesChange(image)}
                            >
                                {selectFiles.includes(image) && (
                                    <CheckSquareFilled
                                        style={{
                                            fontSize: 20,
                                            color: '#09f',
                                        }}
                                    />
                                )}
                            </div>
                        </li>
                    ))}
                    {!videos.length && !images.length && (
                        <div
                            style={{
                                display: 'flex',
                                flex: 1,
                                justifyContent: 'center',
                            }}
                        >
                            <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={intl.get('暂无数据或会话ID错误')}
                            />
                        </div>
                    )}
                </div>
            </Spin>
        </div>
    );
};

export default ZcUpload;
